/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { request as __request } from "../../helpers/api/request";
import type { StatisticPartnersBarChartResponse } from "../../models/statistics/StatisticPartnersBarChartResponse";
import type { StatisticRegionResponse } from "../../models/statistics/StatisticRegionResponse";
import type { StatisticSystemRegionResponse } from "../../models/statistics/StatisticSystemRegionResponse";
import type { StatisticSystemResponse } from "../../models/statistics/StatisticSystemResponse";
import type { StatisticTargetGroupResponse } from "../../models/statistics/StatisticTargetGroupResponse";
import type { StatisticTargetGroupSystemResponse } from "../../models/statistics/StatisticTargetGroupSystemResponse";
import type { StatisticTargetGroupUsersResponse } from "../../models/statistics/StatisticTargetGroupUsersResponse";

export class StatisticsService {
  /**
   * @param from
   * @param to
   * @returns StatisticPartnersBarChartResponse Success
   * @throws ApiError
   */
  public static async getPartnersTop30(from?: string | null, to?: string | null): Promise<Array<StatisticPartnersBarChartResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/partnerstop30`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticSystemResponse Success
   * @throws ApiError
   */
  public static async getSystemsTop30(from?: string | null, to?: string | null): Promise<Array<StatisticSystemResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/systemstop30`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticRegionResponse Success
   * @throws ApiError
   */
  public static async getBrandsTop20(from?: string | null, to?: string | null): Promise<Array<StatisticRegionResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/brandstop20`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticRegionResponse Success
   * @throws ApiError
   */
  public static async getRegions(from?: string | null, to?: string | null): Promise<Array<StatisticRegionResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/regions`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticSystemRegionResponse Success
   * @throws ApiError
   */
  public static async getSystemsWithRegionsTop10(from?: string | null, to?: string | null): Promise<Array<StatisticSystemRegionResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/systemswithregionstop10`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticSystemRegionResponse Success
   * @throws ApiError
   */
  public static async getSystemsWithRegionsTop102(from?: string | null, to?: string | null): Promise<Array<StatisticSystemRegionResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/regionswithsystemstop10`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticTargetGroupResponse Success
   * @throws ApiError
   */
  public static async getTargetGroups(from?: string | null, to?: string | null): Promise<Array<StatisticTargetGroupResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/targetgroups`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticTargetGroupUsersResponse Success
   * @throws ApiError
   */
  public static async getTargetGroupsUsers(from?: string | null, to?: string | null): Promise<Array<StatisticTargetGroupUsersResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/targetgroupsusers`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticSystemRegionResponse Success
   * @throws ApiError
   */
  public static async getSystemsWithTargetGroupsTop20(from?: string | null, to?: string | null): Promise<Array<StatisticSystemRegionResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/systemswithtargetgroupstop20`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @param from
   * @param to
   * @returns StatisticTargetGroupSystemResponse Success
   * @throws ApiError
   */
  public static async getTargetGroupsWithSystemsTop20(from?: string | null, to?: string | null): Promise<Array<StatisticTargetGroupSystemResponse>> {
    const result = await __request({
      method: "GET",
      path: `/statistics/targetgroupswithsystemstop20`,
      query: {
        From: from,
        To: to,
      },
    });
    return result.body;
  }
}
